<div class="calendar-nav">
  <button mat-button class="prev" aria-label="前日へ" (click)="prevClick()">
    <mat-icon svgIcon="arrow"></mat-icon>
  </button>
  <button mat-button class="period" (click)="picker.open()">
    {{ form.value | date: "yyyy年MM月dd日 EEE曜" }}
  </button>
  <button mat-button class="next" aria-label="翌日へ" (click)="nextClick()">
    <mat-icon svgIcon="arrow"></mat-icon>
  </button>
</div>
<input
  type="hidden"
  [matDatepicker]="picker"
  [formControl]="form"
  (dateChange)="onChange()"
/>
<mat-datepicker
  [dateClass]="dateService.dateClass"
  touchUi
  kidspicker
  #picker
></mat-datepicker>
